import { ContentLayoutVariant } from '@silvertours/common-landingpages-view';

type VariantConfig = {
  hasStageAbove: boolean;
  includeTrustSeals: boolean;
  isMinimal: boolean;
  isModernStage: boolean;
  isPlain: boolean;
  isPromo: boolean;
  isErrorPage: boolean;
  showMarketingSlider: boolean;
  showBreadcrumbs: boolean;
};

export const resolveVariantConfig = (
  variant: ContentLayoutVariant,
): VariantConfig => {
  switch (variant.kind) {
    case 'default':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'reviewsPillar':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'plain':
      return {
        hasStageAbove: variant.hasStageAbove,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: false,
        isPlain: true,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'promo':
      return {
        hasStageAbove: variant.hasStageAbove,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: false,
        isPlain: true,
        isPromo: true,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'minimal':
      return {
        hasStageAbove: false,
        includeTrustSeals: false,
        isMinimal: true,
        isModernStage: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: true,
      };
    case 'error':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: true,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'sea':
      return {
        hasStageAbove: true,
        includeTrustSeals: true,
        isMinimal: false,
        isModernStage: true,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    default: {
      const unhandledVariant: never = variant;
      throw new Error(`Unhandled variant: ${(unhandledVariant as any).kind}`);
    }
  }
};
